export interface Tag {
  id: string;
  label: string;
  slug?: string;
  active?: boolean;
}
